import ButtonContainer from 'core/button-container';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import Text from 'core/text';
import TextBox from 'core/text-box';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const WhoNeeds = ({ culture }) => {
    const { seoText, verification } = useGetSeoTextByIndex('home_who_needs');
    const t = useTranslations('who-needs');

    if (!verification) {
        return null;
    };

    const textBoxArray = useMemo(() => (
        Array.from({ length: 6 }, (_, i) => (
            <TextBox
                title={seoText[`item${i + 1}`].title}
                content={seoText[`item${i + 1}`].sentence1}
                imageWidth={50}
                alignImage
                key={i + 1}
            />
        ))
    ), [culture]);

    return (
        <LandingSection>
            <Title content={seoText.section_title} tag="h2" />
            <Text content={seoText.paragraph1.sentence1}/>
            <div className="paragraph_wrapper_short">
                {textBoxArray}
            </div>
            <ButtonContainer>
                <FormOrRedirectButton
                    label={t('button.label')}
                    redirectWithConversio={culture === 'es-ar'}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

WhoNeeds.propTypes = {
    culture: PropTypes.string
};

export default WhoNeeds;
